import React, { useState } from "react";

const About = (props) => {
  /* const [style, setStyle] = useState({
    color: "black",
    backgroundColor: "white",
  });

  let style = {
    color: props.mode ? "black" : "white",
    backgroundColor: props.mode ? "white" : "black",
  };
  const [textchange, setTextchange] = useState("Enable Dark Mode");
  Toggle wrapper , Dark and Light Mode

  function toggleWrap() {
    if (style.color === "black") {
      setStyle({
        color: "white",
        backgroundColor: "black",
        border: "1px solid white",
      });

      setTextchange("Enable Light Mode");
    } else {
      setStyle({
        color: "black",
        backgroundColor: "white",
      });
      setTextchange("Enable Dark Mode");
    }
  }
  */

  let style = {
    color : props.mode ==="dark" ? "white" : "black",
    backgroundColor : props.mode ==="dark" ? 'black' :"white"
  }
  return (
    <>
      <div className="container my-5" style={style}>
        <h1 className="my-5">About Us</h1>
        <div className="accordion my-3" id="accordionExample" style={style}>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                style={style}
              >
                <strong> Analyze Your Text </strong>
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={style}>
                {" "}
                TextUtils give you way to ,This is the first item's accordion
                body. It is shown by default, until the collapse plugin adds the
                appropriate classes that we use to style each element. These
                classes control the overall appearance, as well as the showing
                and hiding via CSS transitions. You can modify any of this with
                custom CSS or overriding our default variables. It's also worth
                noting that just about any HTML can go within the{" "}
                <code>.accordion-body</code>, though the transition does limit
                overflow.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
                style={style}
              >
                <strong> Free to Use </strong>
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={style}>
                {" "}
                TextUtils is free character to use ,This is the second item's
                accordion body. It is hidden by default, until the collapse
                plugin adds the appropriate classes that we use to style each
                element. These classes control the overall appearance, as well
                as the showing and hiding via CSS transitions. You can modify
                any of this with custom CSS or overriding our default variables.
                It's also worth noting that just about any HTML can go within
                the <code>.accordion-body</code>, though the transition does
                limit overflow.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                style={style}
              >
                <strong> Browser Compatible</strong>
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={style}>
                This word counter software is mainly. It is hidden by default,
                until the collapse plugin adds the appropriate classes that we
                use to style each element. These classes control the overall
                appearance, as well as the showing and hiding via CSS
                transitions. You can modify any of this with custom CSS or
                overriding our default variables. It's also worth noting that
                just about any HTML can go within the{" "}
                <code>.accordion-body</code>, though the transition does limit
                overflow.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
